import { ref } from 'vue';

// Estado global para el toast
const showToast = ref(false);
const toastMessage = ref('');

export function useToast() {
  const show = (message) => {
    toastMessage.value = message;
    showToast.value = true;
  };

  const hide = () => {
    showToast.value = false;
  };

  return {
    showToast,
    toastMessage,
    show,
    hide
  };
}
